var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-card"},[_c('span',{staticClass:"empty-card__plus"},[_c('a-icon',{attrs:{"type":"plus"}})],1),_vm._v(" Add project ")])
}
var staticRenderFns = []

export { render, staticRenderFns }